import React from 'react'
import { FaEdit, FaEyeSlash, FaWallet, FaTrashRestore } from 'react-icons/fa'
import { FaPencil, FaRegEye } from 'react-icons/fa6'
import { IoMdTrash } from 'react-icons/io'
import { MdOutlineCancel, MdPrint } from 'react-icons/md'

const EditIcon = ({ iconSize = '17', onClick, className, title = '' }) => {
  return (
    <FaEdit
      size={iconSize}
      className={`text-gray-500 mx-2 cursor-pointer ${className}`}
      onClick={onClick}
      title={title}
    />
  )
}
const DeleteIcon = ({ iconSize = '17', onClick, className, title = '' }) => {
  return (
    <IoMdTrash
      size={iconSize}
      className={`text-red-500 ${className} cursor-pointer`}
      onClick={onClick}
      title={title}
    />
  )
}
const EyeIcon = ({ iconSize = '15', onClick, title = '' }) => {
  return (
    <FaRegEye
      size={iconSize}
      className='text-blue cursor-pointer'
      onClick={onClick}
      title={title}
    />
  )
}
const EyeSlashIcon = ({ iconSize = '15', onClick }) => {
  return (
    <FaEyeSlash
      size={iconSize}
      className='text-blue cursor-pointer'
      onClick={onClick}
    />
  )
}
const PencilIcon = ({ iconSize = '15', onClick }) => {
  return (
    <FaPencil
      size={iconSize}
      className='text-gray-500 cursor-pointer'
      onClick={onClick}
    />
  )
}

const CancelIcon = ({ iconSize = '15', onClick, title = '' }) => {
  return (
    <MdOutlineCancel
      size={iconSize}
      className='text-red-500 cursor-pointer'
      title={title}
      onClick={onClick}
    />
  )
}

const PrintIcon = ({
  iconSize = '15',
  onClick,
  title = 'Print',
  disabled = false
}) => {
  return (
    <MdPrint
      size={iconSize}
      className='text-blue cursor-pointer disabled:text-blue/20'
      title={title}
      onClick={onClick}
      disabled={disabled}
    />
  )
}

const WalletIcon = ({ iconSize = '17', onClick, className, title = '' }) => {
  return (
    <FaWallet
      size={iconSize}
      className={`text-green-600 mx-2 cursor-pointer ${className}`}
      onClick={onClick}
      title={title}
    />
  )
}

const RestoreIcon = ({ iconSize = '17', onClick, className, title = '' }) => {
  return (
    <FaTrashRestore
      size={iconSize}
      className={`text-green-600 mx-2 cursor-pointer ${className}`}
      onClick={onClick}
      title={title}
    />
  )
}

export {
  EditIcon,
  DeleteIcon,
  EyeIcon,
  PencilIcon,
  CancelIcon,
  PrintIcon,
  EyeSlashIcon,
  WalletIcon,
  RestoreIcon
}
